// extracted by mini-css-extract-plugin
export default {"wrap":"Ov-z","logoContainer":"Pv-z","brandImg":"Qv-z","logoImg":"Rv-z","logoButton":"Sv-z"};